/**
 * Fasting plan type enumeration — preset and custom fasting schedules
 */
export var FastingPlanType;
(function (FastingPlanType) {
    FastingPlanType["SIXTEEN_EIGHT"] = "SIXTEEN_EIGHT";
    FastingPlanType["EIGHTEEN_SIX"] = "EIGHTEEN_SIX";
    FastingPlanType["TWENTY_FOUR"] = "TWENTY_FOUR";
    FastingPlanType["OMAD"] = "OMAD";
    FastingPlanType["CUSTOM"] = "CUSTOM";
})(FastingPlanType || (FastingPlanType = {}));
/**
 * Fasting session status enumeration
 */
export var FastingStatus;
(function (FastingStatus) {
    FastingStatus["ACTIVE"] = "ACTIVE";
    FastingStatus["COMPLETED"] = "COMPLETED";
    FastingStatus["BROKEN"] = "BROKEN";
})(FastingStatus || (FastingStatus = {}));
